import { render } from "./EditUser.vue?vue&type=template&id=8d540dea"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__